import React, { Component, Fragment, useEffect } from 'react';
import { Navigationmenu } from '../components';
import CircularProgress from '@material-ui/core/CircularProgress'
import ReactSession from '../reactclient.js';
import { withRouter } from 'react-router-dom';
import circulargridimage from '../gallery/gridloader.gif';

import { fnPostapiResponse, fnGETapiResponse, Fnencryption, Fndecryption } from '../APICall';
import DatePicker from 'react-datepicker';
import moment, { max } from 'moment';
// import 'react-datepicker/dist/react-datepicker.css';
import Footer from '../components/Footer';

//import { Link } from 'react-router-dom'
import { Link } from '@material-ui/core';

import {
    Box,
    Button,
    Typography,
    Grid,
    TextField,
    IconButton,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    FormControl,
    Divider,
    Select,
    InputLabel,
    MenuItem,
    Popover,
    Dialog,
    Tabs,
    Tab,
    DialogActions,
    withStyles,
    TableFooter
} from '@material-ui/core';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';

import {
    SearchOutlined,
    ArrowDropDown,
    Publish,
    NoteAdd,
    ArrowDropUp,
    InsertDriveFileOutlined,
    QueryBuilderTwoTone,
    ContactsOutlined
} from '@material-ui/icons';
import {
    ALTERNATEROW_BACKGROUND_COLOR,
    BLUE_COLOR, LIGHTGRAY_COLOR,
    MODIFIEDBLACK,
    PINK_COLOR,
    PROTECT_GREEN,
    RED_COLOR,
    VIBRANT_GREEN, DARKGREEN_COLOR,
    LIGHTGREEN_COLOR
} from "../constants";
import Switch from '@material-ui/core/Switch';
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import List from "@material-ui/core/List";
import renderIf from 'render-if';
import { Redirect } from "react-router-dom";
import axios from "axios"
import { IdleTimeOutModal } from '../components/Logoutmodal';
import {
    MuiPickersUtilsProvider,
    KeyboardTimePicker,
    KeyboardDatePicker,
} from '@material-ui/pickers';
import AMLScreenImg from '../gallery/AMLScreenImg.jpg';
var CryptoJS = require("crypto-js");

const StyledTabs = withStyles({
    indicator: {
        display: 'flex',
        backgroundColor: 'white',
        height: 3
    },
}, { index: 1 })((props) => <Tabs {...props} TabIndicatorProps={{ children: <span /> }} />);
const SomeComponent = withRouter(props => <SearchPage {...props} />);
const StyledTab = withStyles((theme) => ({
    root: {
        textTransform: 'none',
        color: 'white',
        fontWeight: theme.typography.fontWeightRegular,
        fontSize: theme.typography.pxToRem(15),
        '&:focus': {
            opacity: 1
        }
    },
}, { index: 1 }))((props) => <Tab disableRipple {...props} />);

export default class SearchPage extends Component {
    state = {
        tablebuffer: [],
        pages: 0,
        current: 1,
        records: 0,
        pageSize: 10,
        showPager: false,
        SOURCE: "",
        FNAME: "",
        IsWindowsAuth: "",
        SNAME: "",
        SNAMElabel: "",
        NIC: "",
        NICselectedlabel: "Business Registration Number",
        DOB: "",
        DBUserName: "",
        DBPassword: "",
        DBSource: "",
        DBProvider: "",
        test: false,
        isloading: false,
        pagesObj: [],
        selectedUser: "",
        newOBJ: [],
        selectedPass: "",
        ClientType: [],
        CompanyType: [],
        NATIONALITY: [],
        GENDER: [],
        country: [],
        SelectedClientType: "",

        SelectedCompany: '',
        SelectedClientName: "",
        selectedPassDROP: "",
        ispassdrp: false,
        isclntIndv: false,
        lblnationality: "",
        amlgender: "M",
        selectedOption: true,
        caseid: "",
        selectedCountry: "",
        selectedPAssCountry: "MUS",
        ismandatory: false,
        pageloadingdata: 0,
        nicvaliderror: "",
        todayDate: "",
        displayastric: "none",
        displayclose: "none",
        redirect: false,
        direction: "SearchPage",
        showModal: false,
        isforeignSwitch: false,
        isforeignSwitchChecked: false,
        isdisplayswitch: "block",
        displayForeign: "block",
        displaygorbmbutton: 'none',
        isClientListedOnAml: false
    }
    handleswitchchange(e, country) {
        if (this.state.SelectedClientType == "CORPORATE") {
            if (e && country != "MUS") {
                // debugger
                this.setState({
                    isdisplayswitch: "block", isforeignSwitchChecked: true,
                    NATIONALITY: [
                        {
                            "GRP_VALUES": "LEI",
                            "DESC50": "Legal entity identifier",
                            "ORDERING": "100",
                            "GRP_VALUE1": "CORPORATE"
                        },
                        {
                            "GRP_VALUES": "CRN",
                            "DESC50": "Company registration number",
                            "ORDERING": "120",
                            "GRP_VALUE1": "CORPORATE"
                        }

                    ], NICselectedlabel: "Legal entity identifier",
                    selectedPassDROP: "LEI", ispassdrp: true
                });
            } else {
                this.setState({ isdisplayswitch: "block", isforeignSwitchChecked: false, ispassdrp: false });
                this.FntocheckClienttype(this.state.SelectedClientType, this.state.SelectedCompany)
            }
        }
    }
    getcmp() {

        var data = {
            "MAPIURL": "" + process.env.REACT_APP_SOURCE_URL + "",
            "MAPINAME": 'GETAMLDETAILS',
            "MAPIPORT": '' + process.env.REACT_APP_MPORT + '',
            "body": ''
        }
        // console.log(data)
        fnGETapiResponse(process.env.REACT_APP_SOURCE_URL_MIDDLEWARE, 'GetApiMiddleWare', data, process.env.REACT_APP_PORT_MIDDLEWARE).then((response) => {
            var data = response.data
            console.log(data)
            var cttype = sessionStorage.getItem('ClientType')
            if (cttype != "") {
                cttype = sessionStorage.getItem('ClientType').toUpperCase().trim()
                var Companytype = sessionStorage.getItem('Company').toUpperCase().trim()
                this.setState({
                    CompanyType: data["Company"][0],
                    ClientType: data["ClientType"][0],
                    country: data["Country"][0],
                    NATIONALITY: data["NATIONALITY"][0],
                    GENDER: data["Gender"][0],
                    SelectedCompany: Companytype,
                    SelectedClientType: cttype,
                });
                // this.fnsetclientType(this.state.SelectedClientType)
                this.FntocheckClienttype(cttype, Companytype)
                this.fnsetdatafromtheurl()
                this.setState({ SelectedCompany: Companytype })
            }
            else {
                this.setState({
                    CompanyType: data["Company"][0],
                    ClientType: data["ClientType"][0],
                    country: data["Country"][0],
                    GENDER: data["Gender"][0],
                    SelectedCompany: "SWAN GENERAL",
                    SelectedClientType: "CORPORATE",
                    lblnationality: "Country of Incorporation",
                    isclntIndv: true,
                    amlgender: "O",
                    SNAMElabel: "COMPANY NAME"
                });
                this.state.pageloadingdata = 1
                this.fnsetclientType(this.state.SelectedClientType)
            }

        }).catch(e => console.log(e));
    }
    fngetencryption(body) {

    }
    fetchDetails(rowObj) {
        var clientRName
        var snameR = rowObj['Surname']
        var fnameR = rowObj['First Name']
        var nicR = rowObj['NIC']
        if (nicR == undefined)
            nicR = ''
        var isClientListedOnAmlR = rowObj['Source']
        if (this.state.SelectedClientType == 'CORPORATE')
            clientRName = this.state.SNAME
        else
            clientRName = snameR + " " + fnameR
        var encryptdata = {
            clientName: clientRName,
            ClientType: this.state.SelectedClientType,
            username: this.state.selectedUser,
            isClientListedOnAml: isClientListedOnAmlR,
            Nic: nicR,
            isvalid: 'false'
        }
        var data =
        {
            "MAPIURL": "" + process.env.REACT_APP_SOURCE_URL + "",
            "MAPINAME": 'encryptJson',
            "MAPIPORT": process.env.REACT_APP_MPORT,
            "body": encryptdata
        }
        console.log(data)
        fnPostapiResponse(process.env.REACT_APP_SOURCE_URL_MIDDLEWARE, 'PostApiMiddleWare', data, process.env.REACT_APP_PORT_MIDDLEWARE).then((response) => {
            console.log(response.data['encryptedstr'])
            var endata = response.data['encryptedstr']
            console.log('befare encrypted', encryptdata)
            console.log('After encrypted', endata)
            // console.log('After descryption', decryptedData)
            //  var param = 'clientName='+clientRName+',clientType='+this.state.SelectedClientType+',username='+this.state.selectedUser+',isClientListedOnAml='+isClientListedOnAmlR+',NIC='+nicR+',isValid=false'
            window.open('http://rbm-test.swanforlife.com/#?token=' + endata + '', '_blank');
        }).catch(e => console.log(e));
    }
    fnsetclientType(clnttype) {
        var data =
        {
            "MAPIURL": "" + process.env.REACT_APP_SOURCE_URL + "",
            "MAPINAME": 'GETNICBRN',
            "MAPIPORT": process.env.REACT_APP_MPORT,
            "body": clnttype
        }
        fnGETapiResponse(process.env.REACT_APP_SOURCE_URL_MIDDLEWARE, 'GetApiMiddleWare', data, process.env.REACT_APP_PORT_MIDDLEWARE).then((response) => {
            this.setState({ NATIONALITY: response.data["nicbrnval"][0] })
            //  console.log(this.state.NATIONALITY)
            if (this.state.pageloadingdata == 1) {
                if (
                    clnttype == "CORPORATE"
                )
                    this.setState({
                        NICselectedlabel: "Business Registration Number",
                        selectedPassDROP: "BRN"
                    })
                else {
                    this.setState({
                        NICselectedlabel: "National Identity Card",
                        selectedPassDROP: "NIC"
                    })
                }
            }
            else {
                this.FntocheckpassDrop(this.state.selectedPassDROP, this.state.NIC, this.state.selectedPAssCountry)
                this.setState({
                    pageloadingdata: 1
                })
            }
            // this.fnsetdatafromtheurl()
            // this.state.pageloadingdata = 2



        }).catch(e => console.log(e));
    }
    FntocheckpassDrop(pasdrp, nic, country) {


        var flist = this.state.NATIONALITY.filter((list) => list.GRP_VALUES === pasdrp);

        this.setState({ NICselectedlabel: flist[0]["DESC50"] })
        if (nic == "") {
            this.setState({ caseid: "" })
        }

        if (nic == null)
            nic = ""
        if (pasdrp == "PAS" || pasdrp == "LEI" || pasdrp == "CRN") {
            // if (pasdrp == "PAS")
            this.setState({ ispassdrp: true })
            var caseId = pasdrp + "-" + nic + "-" + country.slice(0, 3)
            this.state.caseid = caseId
            this.setState({ caseid: caseId })
        }
        else {
            this.setState({ ispassdrp: false })
            var caseId = pasdrp + "-" + nic
            this.state.caseid = caseId
            this.setState({ caseid: caseId })

        }

        // alert(this.state.caseid)

    }
    FntocheckClienttype(value, Company) {
        if (value == "INDIVIDUAL") {
            this.setState({ lblnationality: "NATIONALITY", isclntIndv: false, amlgender: "M", SNAMElabel: "SURNAME", displayastric: "block", isforeignSwitchChecked: false, displayForeign: "none", ispassdrp: false })
        }
        else {
            this.setState({ lblnationality: "Country of Incorporation", isclntIndv: true, amlgender: "O", SNAMElabel: "COMPANY NAME", displayastric: "none", isforeignSwitchChecked: false, displayForeign: "block", ispassdrp: false })
        }
        this.fnsetclientType(value)
        //     this.FntocheckpassDrop(this.state.selectedPassDROP, this.state.NIC, this.state.selectedCountry)
        //     // alert(this.state.caseid)
        //     this.setState({
        //        nicvaliderror: ""
        //    })

        //    if (this.state.selectedPassDROP == "NIC") {
        //        alert(this.Nicchecking(this.state.caseid))
        //        this.Nicchecking(this.state.caseid)
        //        }
    }
    handleSomeDateChange(e) {
        if (new Date(e.target.value) > new Date()) {
            alert("DOB Can not be Greater then Today's Date")
            this.setState({ DOB: this.state.todayDate })
        }
        else {


            if (e.target.value == "")
                alert("Please select a valid date")
            else
                this.setState({ DOB: e.target.value })
        }
    }

    fnsetdatafromtheurl() {
        this.state.selectedUser = sessionStorage.getItem('username')
        this.state.selectedPass = sessionStorage.getItem('password')
        this.state.IsWindowsAuth = sessionStorage.getItem('IsWindowsAuth')
        this.state.NIC = sessionStorage.getItem("NIC")
        this.state.SNAME = sessionStorage.getItem('NAME')
        this.state.FNAME = sessionStorage.getItem('FNAME')
        this.state.amlgender = sessionStorage.getItem('GENDER')
        this.state.DOB = sessionStorage.getItem('DOB')
        this.state.SelectedClientName = sessionStorage.getItem('ClientNo')
        this.state.SelectedCompany = sessionStorage.getItem('Company')
        this.state.SelectedClientType = sessionStorage.getItem('ClientType')
        this.state.selectedCountry = sessionStorage.getItem('Country')
        this.state.test = sessionStorage.getItem('IsTest')
        if (sessionStorage.getItem('ClientType') == "CORPORATE") {
            this.state.SNAME = sessionStorage.getItem('ClientCompanyName')
        }
        var nic = this.state.NIC.split("-")
        // console.log("NIC Wala",nic)
        if (nic.length > 1) {
            this.state.selectedPassDROP = nic[0]
            this.state.NIC = nic[1]
            this.FntocheckpassDrop(nic[0], nic[1], "")
        }
        else {
            this.state.selectedPassDROP = "NIC"
            this.state.NIC = nic[0]
            this.FntocheckpassDrop("NIC", nic[0], "")
        }
    }
    RefinitiveresponseandAML(e) {
        this.fntocheckMandatory(e)

        if (this.state.ismandatory) {
            if (e == "QUICK") {
                this.state.selectedOption = true
                this.refinitsearchfun(e)
            }
            else {
                if (this.state.selectedPassDROP == "NIC" && !this.state.isforeignSwitchChecked) {
                    this.state.isloading = true
                    this.Nicchecking(this.state.caseid.toUpperCase().trim())

                }
                else {
                    this.state.selectedOption = false
                    this.refinitsearchfun(e)
                }
            }
        }
    }

    refinitsearchfun(e) {

        this.setState({ alldata: [] })
        this.state.pagesObj = [];
        this.state.newOBJ = [];
        var searchdate = ""
        var searchtype = ""
        if (this.state.selectedOption) {
            var date = new Date()
            var month = date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1
            var date1 = date.getDate() < 10 ? "0" + (date.getDate()) : date.getDate()
            var CMLSELECTEDATE = date.getFullYear() + "-" + month + "-" + date1
            if (this.state.DOB == CMLSELECTEDATE)
                searchdate = ""
            else
                searchdate = this.state.DOB
            searchtype = "QUICK-ONETIME"

        }
        else {
            searchdate = this.state.DOB
            searchtype = this.state.selectedsearchtype

        }
        if (this.state.SelectedClientType == "CORPORATE") {
            searchdate = ""
        }
        var data =
        {
            "MAPIURL": "" + process.env.REACT_APP_SOURCE_URL + "",
            "MAPINAME": 'GetAMLSourceAPI',
            "MAPIPORT": '' + process.env.REACT_APP_MPORT1 + '',
            "body": {
                "NIC": this.state.NIC || "",
                "FNAME": this.state.FNAME || "",
                "SNAME": this.state.SNAME || "",
                "CASELOG_LINKID": "",
                "AMLSource": this.state.SOURCE || "",
                "Company": this.state.SelectedCompany || "",
                "ClientNo": this.state.SelectedClientName || "",
                "ClientType": this.state.SelectedClientType || "",
                "Dob": searchdate || "",
                "Gender": this.state.amlgender || "",
                "Nationality": this.state.selectedCountry || "",
                "CaseId": this.state.caseid || "",
                "DBUserName": this.state.selectedUser || "",
                "DBPassword": Fnencryption(this.state.selectedPass) || "",
                "DBSource": this.state.DBSource || "",
                "DBProvider": this.state.DBProvider || "",
                "QuickFullSearch": this.state.selectedOption || "",
                "Test": this.state.test,
                "IsWindowsAuth": this.state.IsWindowsAuth == null ? "False" : this.state.IsWindowsAuth
            }

        }
        this.state.isloading = true
        // console.log(data)
        fnPostapiResponse(process.env.REACT_APP_SOURCE_URL_MIDDLEWARE, 'PostApiMiddleWare', data, process.env.REACT_APP_PORT_MIDDLEWARE).then((response) => {
            // console.log(response)
            if (response.data.SearchResultMSG == undefined) {
                alert(response.data.Message)
                this.setState({
                    isloading: false,
                    alldata: []
                });
                this.renderpages()
            }
            else {
                var gen = ""
                if (this.state.amlgender == "M")
                    gen = "MALE"
                else
                    gen = "FEMALE"
                var secField = ""
                if (this.state.SelectedClientType == "INDIVIDUAL")
                    secField = [{ "value": gen }, { "value": searchdate }, { "value": this.state.selectedCountry }]
                else
                    secField = [{ "value": this.state.selectedCountry }]
                var data1 =
                {
                    "MAPIURL": "" + process.env.REACT_APP_SOURCE_URL + "",
                    "MAPINAME": 'GetAMLRefinitivAPI',
                    "MAPIPORT": '' + process.env.REACT_APP_MPORT1 + '',
                    "body": {
                        "NIC": this.state.NIC || "",
                        "secondaryFields": secField,
                        "FNAME": this.state.FNAME || "",
                        "SNAME": this.state.SNAME || "",
                        "CASELOG_LINKID": "",
                        "AMLSource": this.state.SOURCE || "",
                        "Company": this.state.SelectedCompany || "",
                        "ClientNo": this.state.SelectedClientName || "",
                        "ClientType": this.state.SelectedClientType || "",
                        "Dob": searchdate || "",
                        "Gender": this.state.amlgender || "",
                        "Nationality": this.state.selectedCountry || "",
                        "CaseId": this.state.caseid || "",
                        "DBUserName": this.state.selectedUser || "",
                        "DBPassword": Fnencryption(this.state.selectedPass) || "",
                        "DBSource": this.state.DBSource || "",
                        "DBProvider": this.state.DBProvider || "",
                        "QuickFullSearch": this.state.selectedOption,
                        "Test": this.state.test,
                        "IsWindowsAuth": this.state.IsWindowsAuth == null ? "False" : this.state.IsWindowsAuth
                    }
                }
                fnPostapiResponse(process.env.REACT_APP_SOURCE_URL_MIDDLEWARE, 'PostApiMiddleWare', data1, process.env.REACT_APP_PORT_MIDDLEWARE).then((response1) => {
                    //console.log("NEWOBJ", response1.data.SearchResultMSG)
                    this.setState({ newOBJ: response1.data.SearchResultMSG })
                    // this.setState({ newOBJ: response1.data.Message })
                    console.log("New OBJ => ", response1.data.SearchResultMSG)
                    console.log("New OBJi => ", this.state.newOBJ)
                    console.log("Search Obj => ", response.data.SearchResultMSG)
                    // console.log("After Merge Obj => ", this.state.newOBJ.concat(response.data.SearchResultMSG))
                    if (this.state.newOBJ == null || this.state.newOBJ == "null") {
                        this.setState({
                            alldata: response.data.SearchResultMSG,
                            isloading: false,
                            displaygorbmbutton: ''
                        })
                        if (process.env.REACT_APP_SOURCE_URL_MIDDLEWARE == 'svr-vm-swnwebap') {
                            this.setState({
                                displaygorbmbutton: 'none'
                            })
                        }
                    }
                    else {
                        if (response.data.SearchResultMSG.concat(this.state.newOBJ).length > 100) {
                            var r = window.confirm("Many Records matched search Criteria. Ok to Proceed or Cancel to redefine Search Criteria")
                            if (r) {
                                this.searchandsave(data, response.data.SearchResultMSG.length, response1.data.SearchResultMSG.length)
                                this.setState({
                                    isloading: false,
                                    alldata: response.data.SearchResultMSG.concat(this.state.newOBJ),
                                    displaygorbmbutton: ''
                                })
                                if (process.env.REACT_APP_SOURCE_URL_MIDDLEWARE == 'svr-vm-swnwebap') {
                                    this.setState({
                                        displaygorbmbutton: 'none'
                                    })
                                }
                                this.renderpages()
                            }
                            else {
                                this.setState({ alldata: [], isloading: false, displaygorbmbutton: 'none' })
                                this.renderpages()
                            }
                        }

                        else {
                            this.searchandsave(data, response.data.SearchResultMSG.length, response1.data.SearchResultMSG.length)

                            this.setState({
                                alldata: response.data.SearchResultMSG.concat(this.state.newOBJ),
                                isloading: false, displaygorbmbutton: ''
                            })
                            if (process.env.REACT_APP_SOURCE_URL_MIDDLEWARE == 'svr-vm-swnwebap') {
                                this.setState({
                                    displaygorbmbutton: 'none'
                                })
                            }
                        }
                    }
                    if (response.data.SearchResultMSG.length > 0 || response.data.SearchResultMSG.concat(this.state.newOBJ).length > 0) { this.setState({ isClientListedOnAml: true }) }
                    else { this.setState({ isClientListedOnAml: false }) }
                    this.renderpages()
                    if (this.state.newOBJ == null || this.state.newOBJ == "null") {
                        if (response.data.SearchResultMSG.length == 0)
                            alert("No data found!")
                    }
                    else {
                        if (response.data.SearchResultMSG.concat(this.state.newOBJ).length == 0)
                            alert("No data found!")
                    }
                }).catch(e => console.log(e),
                );
            }
        }).catch(e => console.log(e),
        );
    }

    componentDidMount() {
        var date = new Date()
        var month = date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1
        var date1 = date.getDate() < 10 ? "0" + (date.getDate()) : date.getDate()
        var CMLSELECTEDATE = date.getFullYear() + "-" + month + "-" + date1
        this.state.todayDate = CMLSELECTEDATE

        //  this.setState({ DOB: "" })
        this.setState({ DOB: CMLSELECTEDATE, selectedUser: sessionStorage.getItem('username') })
        // this.state.selectedUser = sessionStorage.getItem('username')
        this.state.selectedPass = sessionStorage.getItem('password')
        this.state.IsWindowsAuth = sessionStorage.getItem('IsWindowsAuth')

        if (sessionStorage.getItem('isFromWindowApplication')) {
            //    if(process.env.REACT_APP_SOURCE_URL == "svr-vm-devtest")
            if (this.state.IsWindowsAuth) {
                this.setState({
                     DBSource: process.env.REACT_APP_ITC_DBSOURCE,
                    DBProvider: process.env.REACT_APP_ITC_DBPROVIDER,
                    test: process.env.REACT_APP_SOURCE_TEST,
                    displayclose: "block"
                })
            }
            else {
                this.setState({
                     DBUserName: this.state.selectedUser,
                    DBPassword: Fnencryption(this.state.selectedPass),
                    DBSource: process.env.REACT_APP_ITC_DBSOURCE,
                    DBProvider: process.env.REACT_APP_ITC_DBPROVIDER,
                    test: process.env.REACT_APP_SOURCE_TEST,
                    displayclose: "block"
                })

            }

        }
        else {
            var data = {
                "MAPIURL": "" + process.env.REACT_APP_SOURCE_URL + "",
                "MAPINAME": 'GetDbVal',
                "MAPIPORT": '' + process.env.REACT_APP_MPORT + '',
                "body": ''
            }
            fnGETapiResponse(process.env.REACT_APP_SOURCE_URL_MIDDLEWARE, 'GetApiMiddleWare', data, process.env.REACT_APP_PORT_MIDDLEWARE).then((response) => {
                // console.log(response.data)
                if (response != undefined) {
                    this.setState({
                        DBUserName: this.state.selectedUser,
                        DBPassword: Fnencryption(this.state.selectedPass),
                        DBSource: response.data['Source'],
                        DBProvider: response.data['Provider'],
                        test: response.data['Test'],
                        displayclose: "none"
                    })
                }
                else {
                    alert(data)
                }

            }).catch(error => {
                console.log(error);
            })
        }
        this.getcmp()
        // this.fnsetdatafromtheurl()
    }
    isEven(n) {
        return n % 2 == 0;
    }
    pageChange(number) {
        this.state.current = number;
        var data = this.state.alldata.slice(this.state.current * this.state.pageSize, (this.state.current + 1) * this.state.pageSize);
        this.setState({ tablebuffer: data })

        this.state.pagesObj = [];
        if (this.state.pages < 10) {
            for (var i = 0; i < this.state.pages; i++)
                this.state.pagesObj.push(i);
        }
        else {
            var min = this.state.current - 5;
            var max = this.state.current + 5;
            if (min < 0)
                min = 0;
            if (max > this.state.pages)
                max = this.state.pages;
            if (max - min > 10) {
                min = this.state.current - 5;
                max = this.state.current + 5;
            }
            if (min > 0)
                this.state.pagesObj.push(0);
            for (var i = min; i < max; i++)
                this.state.pagesObj.push(i);
            if (max < this.state.pages - 1)
                this.state.pagesObj.push(this.state.pages - 1);
        }
    }
    renderpages() {
        this.state.records = this.state.alldata.length;
        this.state.pages = parseInt(this.state.records / this.state.pageSize)
        if (this.state.records % this.state.pageSize > 0)
            this.state.pages++;
        this.state.showPager = this.state.pages > 1
        this.pageChange(0)
    }
    handleSerachChange(e, key) {
        this.setState({ key: e.target.value });
        this.state[key] = e.target.value;
    }
    handlefocusout(e) {
        this.FntocheckpassDrop(this.state.selectedPassDROP, e.target.value, this.state.selectedPAssCountry)
        // // alert(this.state.caseid)
        // this.setState({
        //     nicvaliderror: ""
        // })

        // if (this.state.selectedPassDROP == "NIC")
        //     this.Nicchecking(e.target.value)
    }
    Nicchecking(e) {
        if (this.state.NIC.trim() == "") {
            alert("Please Enter Valid NIC")
        }
        else {
            var data =
            {
                "MAPIURL": "" + process.env.REACT_APP_SOURCE_URL + "",
                "MAPINAME": 'ValidateNIC',
                "MAPIPORT": '' + process.env.REACT_APP_MPORT1 + '',
                "body": {
                    "strFirstCharToCheck": "",
                    "strSurname": this.state.SNAME.trim(),
                    "strMaiden": "",
                    "strSex": "",
                    "strDOB": "",
                    "strCountryCode": this.state.selectedCountry.trim(),
                    "strNic": e.trim(),
                    "strStatus": "",
                    "strMessage": "",
                    "blCheckDigitOnly": true,
                    "test": this.state.test
                }
            }
            console.log("Nic Body", data)

            fnPostapiResponse(process.env.REACT_APP_SOURCE_URL_MIDDLEWARE, 'PostApiMiddleWare', data, process.env.REACT_APP_PORT_MIDDLEWARE).then((response) => {
                console.log(response.data)
                this.setState({
                    nicvaliderror: response.data
                })
                // this.state.nicvaliderror = response.data
                if (this.state.nicvaliderror == true) {
                    this.state.selectedOption = false
                    this.refinitsearchfun(e)
                }
                else {
                    alert(this.state.nicvaliderror)
                    this.setState({
                        NIC: "",
                        isloading: false,
                        tablebuffer: [],
                        pagesObj: []
                    })
                    return
                }
            }).catch(e => console.log(e),
            );
        }
    }




    searchandsave(data, count, refinitivCount) {
        var searchdate = ""
        var searchtype = ""
        if (this.state.selectedOption) {
            var date = new Date()
            var month = date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1
            var date1 = date.getDate() < 10 ? "0" + (date.getDate()) : date.getDate()
            var CMLSELECTEDATE = date.getFullYear() + "-" + month + "-" + date1
            if (this.state.DOB == CMLSELECTEDATE)
                searchdate = ""
            else
                searchdate = this.state.DOB
            searchtype = "QUICK-ONETIME"

        }
        else {
            searchdate = this.state.DOB
            searchtype = this.state.selectedsearchtype
        }
        if (this.state.SelectedClientType == "CORPORATE") {
            searchdate = ""
        }
        var data1 = {
            "MAPIURL": "" + process.env.REACT_APP_SOURCE_URL + "",
            "MAPINAME": 'SaveAMLSourceAPI?AMLSearchCount=' + count + '&RefinitivSearchCount=' + refinitivCount,
            "MAPIPORT": '' + process.env.REACT_APP_MPORT1 + '',
            "body": {
                "NIC": this.state.NIC || "",
                "FNAME": this.state.FNAME || "",
                "SNAME": this.state.SNAME || "",
                "CASELOG_LINKID": "",
                "AMLSource": this.state.SOURCE || "",
                "Company": this.state.SelectedCompany || "",
                "ClientNo": this.state.SelectedClientName || "",
                "ClientType": this.state.SelectedClientType || "",
                "Dob": searchdate || "",
                "Gender": this.state.amlgender || "",
                "Nationality": this.state.selectedCountry || "",
                "CaseId": this.state.caseid || "",
                "DBUserName": this.state.selectedUser || "",
                "DBPassword": Fnencryption(this.state.selectedPass) || "",
                "DBSource": this.state.DBSource || "",
                "DBProvider": this.state.DBProvider || "",
                "QuickFullSearch": this.state.selectedOption || "",
                "Test": this.state.test,
                "IsWindowsAuth": this.state.IsWindowsAuth == null ? "False" : this.state.IsWindowsAuth
            }
        }
        //  console.log("da",data1)
        fnPostapiResponse(process.env.REACT_APP_SOURCE_URL_MIDDLEWARE, 'PostApiMiddleWare', data1, process.env.REACT_APP_PORT_MIDDLEWARE).then((response) => {
            // console.log("Data",response.data)

        }).catch(e => console.log(e),
            // this.setState({ alldata: [], isloading: false }),
            // this.renderpages()
        );
    }
    setRadioState(e) {
        this.setState({
            selectedOption: e
        });
    }
    rbmButtonClick = () => {
        // var r = window.confirm("Do you want to logout?")
        // if (r == true) {
        //     this.setState({
        //         redirect: true,
        //         direction: '/'
        //     })
        // }

        var clientRName
        if (this.state.SelectedClientType == 'CORPORATE')
            clientRName = this.state.SNAME
        else
            clientRName = this.state.SNAME + " " + this.state.FNAME
        var clientRName
        var nicR = ''
        if (nicR == undefined)
            nicR = ''
        var isClientListedOnAmlR = ''

        var encryptdata = {
            clientName: clientRName,
            ClientType: this.state.SelectedClientType,
            username: this.state.selectedUser,
            isClientListedOnAml: isClientListedOnAmlR,
            Nic: nicR,
            isvalid: 'false'
        }
        var data =
        {
            "MAPIURL": "" + process.env.REACT_APP_SOURCE_URL + "",
            "MAPINAME": 'encryptJson',
            "MAPIPORT": process.env.REACT_APP_MPORT,
            "body": encryptdata
        }
        console.log(data)
        fnPostapiResponse(process.env.REACT_APP_SOURCE_URL_MIDDLEWARE, 'PostApiMiddleWare', data, process.env.REACT_APP_PORT_MIDDLEWARE).then((response) => {
            console.log(response.data['encryptedstr'])
            var endata = response.data['encryptedstr']
            console.log('befare encrypted', encryptdata)
            console.log('After encrypted', endata)
            // console.log('After descryption', decryptedData)
            // var param = 'clientName='+clientRName+',clientType='+this.state.SelectedClientType+',username='+this.state.selectedUser+',isClientListedOnAml='+isClientListedOnAmlR+',NIC='+nicR+',isValid=false'
            window.open('' + process.env.REACT_APP_SOURCE_GORBMURL + '/#?token=' + endata + '', '_blank');
        }).catch(e => console.log(e));

        // var param = 'clientName=' + clientRName + ',clientType=' + this.state.SelectedClientType + ',username=' + this.state.selectedUser + ',isClientListedOnAml=' + this.state.isClientListedOnAml + ',isValid=false'
        //  window.location.assign('http://rbm-test.swanforlife.com/','_blank');
        // window.open('http://rbm-test.swanforlife.com/#?' + param + '', '_blank');

    }

    handlereset(e) {
        var r = window.confirm("Do you want to Clear ?")
        var date = new Date()
        var month = date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1
        var date1 = date.getDate() < 10 ? "0" + (date.getDate()) : date.getDate()
        var CMLSELECTEDATE = date.getFullYear() + "-" + month + "-" + date1
        if (r == true) {
            this.setState({
                NIC: "",
                SNAME: "",
                FNAME: "",
                amlgender: "o",
                DOB: CMLSELECTEDATE,
                SelectedCompany: "SWAN GENERAL",
                SelectedClientName: "",
                SelectedClientType: "CORPORATE", selectedCountry: "",
                selectedPassDROP: "NIC",
                tablebuffer: [],
                pagesObj: [],
                ispassdrp: false, isforeignSwitchChecked: false,
                displayForeign: "block",
                displaygorbmbutton: 'none'
            })
            this.FntocheckClienttype("CORPORATE", "SWAN GENERAL")
            // this.FntocheckpassDrop("BRN", "", "")
            //window.close()
        }
    }

    fntocheckMandatory(e) {
        if (e == "QUICK") {
            if (this.state.SNAME == "") {
                if (this.state.SelectedClientType == "CORPORATE")
                    alert("Please enter all mandatory detail (Company Name)")
                else
                    alert("Please enter all mandatory detail (Surname)")

                this.state.ismandatory = false
            }
            else {
                this.state.ismandatory = true
            }

        }
        else {
            if (true) {
                if (this.state.SNAME == "" || this.state.selectedCountry == "" || this.state.NIC == "") {
                    if (this.state.SelectedClientType == "CORPORATE") {
                        if (this.state.isforeignSwitchChecked)
                            alert("Please enter all mandatory details (Company Name, Country of Incorporation And LEI/CRN)")
                        else
                            alert("Please enter all mandatory details (Company Name, Country of Incorporation And  BRN/ASC/CRB/CLB/HCM)")
                    } else
                        alert("Please enter all mandatory details (Surname, DOB, Gender, Nationality And NIC/PAS/COM)")
                    this.state.ismandatory = false
                }
                else {
                    this.state.ismandatory = true
                }
            }
            else {
                if (this.state.SNAME == "" || this.state.selectedCountry == "") {
                    if (this.state.SelectedClientType == "CORPORATE")
                        alert("Please enter all mandatory details (Company Name, Country of Incorporation)")
                    else
                        alert("Please enter all mandatory details (Surname, DOB, Gender, Nationality)")
                    this.state.ismandatory = false
                }
                else {
                    this.state.ismandatory = true
                }
            }
        }
    }
    handleLogout() {
        this.setState({
            redirect: true,
            direction: '/'
        })
    }
    handleGeneratePdf() {
        window.print();
    }

    render() {

        return (

            // <Fragment>
            //     {this.state.redirect &&
            //         <Redirect to={this.state.direction} />
            //     }
            //     <Navigationmenu selectedMenu={'AMLSEARCH'} />

            //     <IdleTimeOutModal
            //         showModal={this.state.showModal}
            //         handleClose={this.handleClose}
            //         handleLogout={this.handleLogout}

            //     />

            //     <div>
            //         <center style={{ marginTop:70 }}>
            //             <h1><u  style={{ borderWidth: 0, color: BLUE_COLOR,  fontFamily: 'Globerbold', fontSize: 30,}}>
            //                 <Link href="http://svr-vm-swnwebap:7002/#/ConsPgm" target="_blank" rel="noopener noreferrer">
            //                     Below screen is moved to new URL. Please click here and login into new URL.
            //                 </Link></u>
            //             </h1>
            //             <img style={{filter:'grayscale(100%)'}} src={AMLScreenImg}></img>
            //         </center>
            //     </div>
            // </Fragment>
            <Fragment>
                {this.state.redirect &&
                    <Redirect to={this.state.direction} />
                }
                <Navigationmenu selectedMenu={'AMLSEARCH'} />

                <IdleTimeOutModal
                    showModal={this.state.showModal}
                    handleClose={this.handleClose}
                    handleLogout={this.handleLogout}

                />
                <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    style={{ marginTop: 35 }}
                >
                    <Paper elevation={2} style={{ minHeight: 100, width: '90%', borderRadius: 6 }}>
                        <Box
                            display="flex"
                            alignItems="center"
                            justifyContent="center"
                        >
                            <div style={{ minHeight: 100, width: '98%', borderRadius: 6 }}>

                                <Grid container spacing={2} >
                                    <Grid item xs={11}>
                                        <div style={{
                                            display: 'flex',
                                            marginBottom: 20,
                                            marginTop: 60
                                        }}>
                                            <Typography style={{ borderWidth: 0, color: BLUE_COLOR, textTransform: 'uppercase', fontFamily: 'Globerbold', fontSize: 30, paddingLeft: 10 }}>AML SEARCH</Typography>
                                            <Link style={{ borderWidth: 0, color: BLUE_COLOR, textTransform: 'uppercase', fontFamily: 'Globerbold', fontSize: 10, paddingRight: 10 }} href="http://svr-vm-swnwebap:7002/#/ConsPgm" target="_blank" rel="noopener noreferrer">
                                                Link
                                            </Link>
                                        </div>
                                    </Grid>
                                    <Grid item xs={1}>
                                        <Box
                                            display="flex"
                                            alignItems="center"
                                            justifyContent="center"
                                        >
                                        </Box>
                                    </Grid>
                                </Grid>
                                <Grid container spacing={2} style={{ marginBottom: 30 }}>


                                    <Grid item xs={1} style={{ fontSize: "15px", fontFamily: 'Globerbold', color: BLUE_COLOR }}  >
                                        COMPANY
                                    </Grid>
                                    <Grid item xs={3}>
                                        <Select fullWidth
                                            variant={'outlined'}
                                            value={this.state.SelectedCompany}
                                            onChange={e => this.setState({ SelectedCompany: e.target.value }
                                                , this.FntocheckClienttype(this.state.SelectedClientType, e.target.value))
                                            }

                                        >
                                            {this.state.CompanyType.map(team => (
                                                <MenuItem value={team.COMPANY}>{team.COMPANY}</MenuItem>
                                            ))}
                                        </Select>
                                    </Grid>

                                    <Grid item xs={1} style={{ marginLeft: "10px", fontSize: "15px", fontFamily: 'Globerbold', color: BLUE_COLOR }}>
                                        CLIENT TYPE</Grid>

                                    <Grid item xs={3}>
                                        <Select fullWidth
                                            variant={'outlined'}
                                            value={this.state.SelectedClientType}
                                            onChange={e => this.setState({ SelectedClientType: e.target.value },
                                                this.FntocheckClienttype(e.target.value, this.state.SelectedCompany))}

                                        >
                                            {this.state.ClientType.map(team => (
                                                <MenuItem value={team.CLIENTTYPE}>{team.CLIENTTYPE}</MenuItem>
                                            ))}
                                        </Select>
                                    </Grid>


                                    <Grid item xs={3} style={{ marginLeft: "30px" }}>
                                        <TextField fullWidth label="CLIENT NUMBER" value={this.state.SelectedClientName}
                                            onChange={(e) => this.handleSerachChange(e, "SelectedClientName")}
                                            InputProps={{ style: { fontFamily: 'Globerbold', color: MODIFIEDBLACK } }}
                                            InputLabelProps={{ style: { fontFamily: 'Globerbold', color: BLUE_COLOR } }} />
                                    </Grid>


                                </Grid>

                                {/*FILTER DROPDOWNS*/}
                                {!this.state.expanded && <Grid container spacing={3} style={{ marginBottom: 30 }}>
                                    <Grid item xs={2}>
                                        <FormControl fullWidth >
                                            <TextField label={this.state.SNAMElabel}
                                                value={this.state.SNAME}
                                                onChange={(e) => this.handleSerachChange(e, "SNAME")}
                                                onBlur={e => this.setState({ SNAME: e.target.value.substring(0, 50) })}
                                                InputProps={{ style: { fontFamily: 'Globerbold', color: MODIFIEDBLACK } }}
                                                InputLabelProps={{ style: { fontFamily: 'Globerbold', color: BLUE_COLOR } }}
                                            />
                                        </FormControl>
                                    </Grid>
                                    <label style={{ color: VIBRANT_GREEN, fontSize: 35 }}>*</label>
                                    <label style={{ color: RED_COLOR, fontSize: 35, marginLeft: 1 }}>*</label>

                                    <Grid item xs={2}>
                                        <FormControl fullWidth>
                                            <TextField disabled={this.state.isclntIndv} label="FIRST NAME" style={{ width: '100%' }}
                                                value={this.state.FNAME}
                                                onChange={(e) => this.handleSerachChange(e, "FNAME")}
                                                InputProps={{ style: { fontFamily: 'Globerbold', color: MODIFIEDBLACK } }}
                                                InputLabelProps={{ style: { fontFamily: 'Globerbold', color: BLUE_COLOR } }}
                                            />
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={1} style={{ marginLeft: "1px", fontSize: "16px", fontFamily: 'Globerbold', color: BLUE_COLOR }}>
                                        DOB</Grid>
                                    <Grid item xs={2} style={{ marginLeft: "-60px" }}>
                                        {/* <FormControl fullWidth>
                                            <TextField label="DOB" disabled ={this.state.isclntIndv} style={{ width: '100%' }}
                                                value={this.state.DOB} onChange={(e) => this.handleSerachChange(e, "DOB")}
                                                InputProps={{ style: { fontFamily: 'Globerbold', color: MODIFIEDBLACK } }}
                                                InputLabelProps={{ style: { fontFamily: 'Globerbold', color: 'gray' } }} />
                                        </FormControl> */}
                                        <TextField fullWidth id="date" disabled={this.state.isclntIndv} label=""
                                            type="date"
                                            value={this.state.DOB}
                                            className="form-control"
                                            variant="outlined"
                                            onChange={e => this.handleSomeDateChange(e)}
                                            inputProps={{
                                                max: "" + this.state.todayDate + "",
                                                style: { fontFamily: 'Globerbold' }
                                            }}
                                            InputLabelProps={{ style: { fontFamily: 'Globerbold', color: BLUE_COLOR } }}
                                        />

                                    </Grid>
                                    {/* <label style={{color:DARKGREEN_COLOR,fontSize:20}}>*</label> */}
                                    <label style={{ color: RED_COLOR, fontSize: 35, display: "" + this.state.displayastric + "" }}>*</label>


                                    <Grid item xs={1} style={{ marginLeft: "0px", fontSize: "16px", fontFamily: 'Globerbold', color: BLUE_COLOR }}>
                                        GENDER</Grid>
                                    <Grid item xs={2}>
                                        <Select fullWidth disabled={this.state.isclntIndv}
                                            variant={'outlined'}
                                            value={this.state.amlgender}
                                            onChange={e => this.setState({
                                                amlgender: e.target.value
                                            })}
                                        >
                                            <MenuItem value="O">UNSPECIFIED</MenuItem>
                                            {this.state.GENDER.map(team => (
                                                <MenuItem value={team.CODE}>{team.DESCRIPTION}</MenuItem>
                                            ))}
                                        </Select>

                                    </Grid>
                                    {/* <label style={{color:DARKGREEN_COLOR,fontSize:20}}>*</label> */}
                                    <label style={{ color: RED_COLOR, fontSize: 35, display: "" + this.state.displayastric + "" }}>*</label>
                                    <Grid item xs={1} style={{ marginLeft: "0px", fontSize: "16px", fontFamily: 'Globerbold', color: BLUE_COLOR, display: this.state.displayForeign }}>
                                        FOREIGN</Grid>
                                    <Grid item xs={1} style={{ display: this.state.displayForeign }}>
                                        <Switch
                                            disabled={this.state.isforeignSwitch}
                                            checked={this.state.isforeignSwitchChecked}
                                            onChange={e => this.handleswitchchange(e.target.checked, this.state.selectedCountry)}
                                            color="primary"
                                            name="checkedB"
                                            inputProps={{ 'aria-label': 'primary checkbox' }}
                                        />
                                    </Grid>
                                </Grid>}
                                {/*FILTER DROPDOWNS*/}

                                <Grid container spacing={2}>
                                    <Grid item xs={1} style={{ fontSize: "16px", marginRight: "8px", fontFamily: 'Globerbold', color: BLUE_COLOR }}>
                                        {this.state.lblnationality}
                                    </Grid>
                                    <Grid item xs={2}>

                                        <Select fullWidth
                                            variant={'outlined'}
                                            value={this.state.selectedCountry}
                                            onChange={e => this.setState({ selectedCountry: e.target.value }
                                                , this.handleswitchchange(true, e.target.value))}
                                        >
                                            {this.state.country.map(team => (
                                                <MenuItem value={team.CODE}>{team.DESCRIPTION}</MenuItem>
                                            ))}
                                        </Select>             </Grid>
                                    <label style={{ color: RED_COLOR, fontSize: 35 }}>*</label>

                                    <Grid item xs={1}>

                                        <Select fullWidth
                                            variant={'outlined'}
                                            value={this.state.selectedPassDROP}
                                            onChange={e => this.setState({
                                                selectedPassDROP: e.target.value
                                            },
                                                this.FntocheckpassDrop(e.target.value, this.state.NIC, this.state.selectedPAssCountry))}
                                        >
                                            {this.state.NATIONALITY.map(team => (
                                                <MenuItem value={team.GRP_VALUES}>{team.GRP_VALUES}</MenuItem>
                                            ))}
                                        </Select>
                                    </Grid>
                                    <Grid item xs={3}>
                                        <TextField
                                            fullWidth label={this.state.NICselectedlabel} value={this.state.NIC}
                                            onChange={(e) => this.handleSerachChange(e, "NIC")}
                                            onBlur={(e) => this.handlefocusout(e, "NIC")} InputProps={{ style: { fontFamily: 'Globerbold', color: MODIFIEDBLACK } }}
                                            InputLabelProps={{ style: { fontFamily: 'Globerbold', color: BLUE_COLOR } }} />
                                    </Grid>
                                    <label style={{ display: this.state.isdisplayswitch, color: RED_COLOR, fontSize: 35 }}>*</label>

                                    <Grid style={{ display: this.state.ispassdrp ? "" : "none" }} item xs={2}>
                                        <Select fullWidth
                                            variant={'outlined'}
                                            value={this.state.selectedPAssCountry}
                                            onChange={e => this.setState({ selectedPAssCountry: e.target.value },

                                                this.FntocheckpassDrop(this.state.selectedPassDROP, this.state.NIC, e.target.value))}
                                        >
                                            {this.state.country.map(team => (
                                                <MenuItem value={team.CODE}>{team.DESCRIPTION}</MenuItem>
                                            ))}
                                        </Select>
                                    </Grid>
                                    <Grid style={{ display: 'none' }}>
                                        <TextField fullWidth label="CASE ID" disabled
                                            value={this.state.caseid}
                                            onChange={(e) => this.handleSerachChange(e, "caseid")} variant="outlined"
                                        />
                                    </Grid>
                                    <Grid style={{ display: "flex", justify: "flex-end" }} item xs={4}>

                                        <Button variant={'text'} onClick={(e) => this.RefinitiveresponseandAML("QUICK")} style={{ color: 'white', fontFamily: 'Globerbold', backgroundColor: VIBRANT_GREEN, width: '30%', fontSize: 18 }}>
                                            QUICK
                                        </Button>

                                        <Button variant={'text'} onClick={(e) => this.RefinitiveresponseandAML("FULL")} style={{ color: 'white', marginLeft: '2px', display: this.state.isDisplayFullButton, fontFamily: 'Globerbold', backgroundColor: RED_COLOR, width: '30%', fontSize: 18 }}>
                                            FULL
                                        </Button>
                                        <Button variant={'text'} onClick={(e) => this.handlereset(e)} style={{ color: 'white', fontFamily: 'Globerbold', marginLeft: "2px", backgroundColor: BLUE_COLOR, width: '30%', fontSize: 18 }}>
                                            CLEAR
                                        </Button>
                                        <Button variant={'text'} onClick={(e) => this.rbmButtonClick()} style={{ color: 'white', display: this.state.displaygorbmbutton, marginLeft: '2px', fontFamily: 'Globerbold', backgroundColor: BLUE_COLOR, width: '30%', fontSize: 18 }}>
                                            Go RBM
                                        </Button>
                                        <Button variant={'text'} onClick={(e) => this.handleGeneratePdf(e)} style={{ color: 'white', fontFamily: 'Globerbold', marginLeft: "2px", backgroundColor: BLUE_COLOR, width: '30%', fontSize: 18 }}>
                                            Print Report
                                        </Button>
                                    </Grid>

                                </Grid>
                                <br></br>

                                <Grid item xs><TableContainer>
                                    <Table aria-label="table">
                                        <TableHead style={{ backgroundColor: 'rgba(241,241,241,1.0)' }}>
                                            <TableRow>
                                                <TableCell style={{ borderWidth: 0, width: "150px", color: MODIFIEDBLACK, textTransform: 'uppercase', fontFamily: 'Globerbold' }} align="left">NIC</TableCell>
                                                <TableCell style={{ borderWidth: 0, width: "150px", color: MODIFIEDBLACK, textTransform: 'uppercase', fontFamily: 'Globerbold' }} align="left">First Name</TableCell>
                                                <TableCell style={{ borderWidth: 0, width: "150px", color: MODIFIEDBLACK, textTransform: 'uppercase', fontFamily: 'Globerbold' }} align="left">Surname</TableCell>
                                                <TableCell style={{ borderWidth: 0, width: "100px", color: MODIFIEDBLACK, textTransform: 'uppercase', fontFamily: 'Globerbold' }} align="left">Country</TableCell>
                                                <TableCell style={{ borderWidth: 0, width: "120px", color: MODIFIEDBLACK, textTransform: 'uppercase', fontFamily: 'Globerbold' }} align="left">Source</TableCell>
                                                <TableCell style={{ borderWidth: 0, width: "150px", color: MODIFIEDBLACK, textTransform: 'uppercase', fontFamily: 'Globerbold' }} align="left">Line of Control</TableCell>
                                                <TableCell style={{ borderWidth: 0, width: "100px", color: MODIFIEDBLACK, textTransform: 'uppercase', fontFamily: 'Globerbold' }} align="left">IssueDate</TableCell>
                                                {/* <TableCell style={{ borderWidth: 0, width: "90px", color: MODIFIEDBLACK, textTransform: 'uppercase', fontFamily: 'Globerbold' }} align="left">SetNo</TableCell> */}
                                                <TableCell style={{ borderWidth: 0, width: "80px", color: MODIFIEDBLACK, textTransform: 'uppercase', fontFamily: 'Globerbold' }} align="left">Color</TableCell>
                                                {/* <TableCell style={{ borderWidth: 0, width: "80px", color: MODIFIEDBLACK, textTransform: 'uppercase', fontFamily: 'Globerbold' }} align="left">Go rbm</TableCell> */}
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {!this.state.isloading ?
                                                this.state.tablebuffer.map((obj, index) => {
                                                    var rowbackgroundColor = 'white';
                                                    if (this.isEven(index)) { rowbackgroundColor = ALTERNATEROW_BACKGROUND_COLOR; }

                                                    if (this.state.ishovered && this.state.hoverindex == index) { rowbackgroundColor = LIGHTGRAY_COLOR }
                                                    if (obj != undefined) {
                                                        return (
                                                            <TableRow style={{ cursor: 'pointer' }} key={index} hover={true} onMouseOut={() => this.setState({ ishovered: false })} onMouseEnter={() => this.setState({ hoverindex: index, ishovered: true })}>
                                                                <TableCell style={{ borderWidth: 0, whiteSpace: 'unset', color: BLUE_COLOR, textTransform: 'uppercase', fontFamily: 'Globerbold', backgroundColor: rowbackgroundColor }} align="left">{obj.NIC}</TableCell>
                                                                <TableCell style={{ borderWidth: 0, whiteSpace: 'unset', color: BLUE_COLOR, textTransform: 'uppercase', fontFamily: 'Globerbold', backgroundColor: rowbackgroundColor }} align="left">{obj["First Name"]}{obj["FirstName"]} </TableCell>
                                                                <TableCell style={{ borderWidth: 0, whiteSpace: 'unset', color: BLUE_COLOR, textTransform: 'uppercase', fontFamily: 'Globerbold', backgroundColor: rowbackgroundColor }} align="left">{obj.Surname}</TableCell>
                                                                <TableCell style={{ borderWidth: 0, whiteSpace: 'unset', color: BLUE_COLOR, textTransform: 'uppercase', fontFamily: 'Globerbold', backgroundColor: rowbackgroundColor }} align="left">{obj["Country"]}</TableCell>
                                                                <TableCell style={{ borderWidth: 0, whiteSpace: 'unset', color: BLUE_COLOR, textTransform: 'uppercase', fontFamily: 'Globerbold', backgroundColor: rowbackgroundColor }} align="left">{obj["Source"]}</TableCell>
                                                                <TableCell style={{ borderWidth: 0, whiteSpace: 'unset', color: BLUE_COLOR, textTransform: 'uppercase', fontFamily: 'Globerbold', backgroundColor: rowbackgroundColor }} align="left">{obj["Line of Control"]}{obj["LineOfControl"]}</TableCell>
                                                                <TableCell style={{ borderWidth: 0, whiteSpace: 'unset', color: BLUE_COLOR, textTransform: 'uppercase', fontFamily: 'Globerbold', backgroundColor: rowbackgroundColor }} align="left">{obj["IssueDate"]}</TableCell>
                                                                {/* <TableCell style={{ borderWidth: 0, whiteSpace: 'unset', color: BLUE_COLOR, textTransform: 'uppercase', fontFamily: 'Globerbold', backgroundColor: rowbackgroundColor }} align="left">{obj["SetNo"]}</TableCell> */}
                                                                {/* <TableCell style={{width: 0,height: 0,borderRadius: '50%',backgroundColor: obj["ColorCoding"],padding:10}}></TableCell> */}
                                                                <TableCell style={{ margin: 'auto', marginTop: 30, display: "block", lineHeight: 20, width: 0, height: 0, borderRadius: '50%', backgroundColor: obj["ColorCoding"] }}></TableCell>
                                                                {/* <TableCell style={{ borderWidth: 0, color: BLUE_COLOR, textTransform: 'uppercase', fontFamily: 'Globerbold', backgroundColor: rowbackgroundColor }} align="left" ><Button as={Link} onClick={(e) => this.fetchDetails(obj)} style={{ color: BLUE_COLOR, fontFamily: 'Globerbold', textDecorationLine: 'underline', fontSize: 15 }}>
                                                                    Go RBM
                                                                </Button></TableCell> */}


                                                            </TableRow>
                                                        )
                                                    }
                                                })
                                                : <td style={{ marginLeft: "500px", height: "100px" }}>
                                                    {/* Loading.... <CircularProgress classes="CircularProgress" /> */}
                                                    <img style={{ width: "100px" }} src={circulargridimage} alt="circulargridimage" />;
                                                </td>}
                                        </TableBody>
                                    </Table>
                                    <div style={this.state.showPager ? { height: 60, marginLeft: "500px", color: MODIFIEDBLACK, fontSize: "15px", textTransform: 'uppercase', fontFamily: 'Globerbold', wordBreak: "break-word" } : { display: "none" }} >
                                        {
                                            this.state.pagesObj.map((obj, index) => {
                                                return (
                                                    <span style={{ padding: "0 3px", cursor: "pointer" }}>
                                                        <a style={this.state.current == obj ? { fontWeight: 'bold', color: BLUE_COLOR, fontSize: "30px" } : {}} onClick={() => this.pageChange(obj)} >{obj + 1}</a>
                                                    </span>
                                                )
                                            })
                                        }
                                    </div>
                                </TableContainer>
                                </Grid>
                                <Divider></Divider>
                                <br></br>
                                Disclaimer: You are kindly advised that we will retain audit trails of searches made on the AML Watchlist for monitoring purposes.
                                <br></br>
                                {/* <Footer></Footer> */}
                                <br></br>
                            </div>
                        </Box>
                    </Paper>
                </Box>
            </Fragment>
        )
    }
}